export const ProductionSocketStagePosition = (
	json: IProductionSocketStagePosition,
): IProductionSocketStagePositionModel => {
	const { machine_id, is_active, ...rest } = json

	return {
		machineID: machine_id || null,
		isActive: is_active,
		...rest,
	}
}

export const ProductionSocketMachine = (json: IProductionSocketStageMachine): IProductionSocketStageMachineModel => {
	const { created_at, updated_at, machine_crm_id, machine_type_uuid, short_name, ...rest } = json

	return {
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		machineCrmID: machine_crm_id,
		machineTypeUUID: machine_type_uuid,
		shortName: short_name,
		...rest,
	}
}

export const ProductionSocketMachineTypePivot = (
	json: IProductionSocketStageMachineTypePivot,
): IProductionSocketStageMachineTypePivotModel => {
	const { created_at, updated_at, production_machine_type_uuid, production_stage_uuid, ...rest } = json

	return {
		...rest,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		productionMachineTypeUUID: production_machine_type_uuid,
		productionStageUUID: production_stage_uuid,
	}
}

export const ProductionSocketStageMachineType = (
	json: IProductionSocketStageMachineType,
): IProductionSocketStageMachineTypeModel => {
	const { created_at, updated_at, machines, pivot, ...rest } = json

	return {
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		machines: machines ? machines.map(ProductionSocketMachine) : [],
		pivot: ProductionSocketMachineTypePivot(pivot),
		...rest,
	}
}

export const ProductionSocketBasicMachineType = (
	json: IProductionSocketBasicMachineType,
): IProductionSocketBasicMachineTypeModel => {
	const { ...rest } = json

	return {
		...rest,
	}
}

export const ProductionSocketStage = (json: IProductionSocketStage): IProductionSocketStageModel => {
	const { short_name, is_added, machine_types, positions, ...rest } = json

	return {
		isAdded: is_added,
		shortName: short_name,
		machineTypes: machine_types ? machine_types.map(ProductionSocketStageMachineType) : [],
		positions: positions ? positions.map(ProductionSocketStagePosition) : [],
		...rest,
	}
}

export const ProductionSocket = (json: IProductionSocket): IProductionSocketModel => {
	const { is_active, created_at, updated_at, stages, stages_count, ...rest } = json

	return {
		...rest,
		stages: stages ? stages.map(ProductionSocketStage) : [],
		stagesCount: stages_count,
		isActive: is_active,
		createdAt: new Date(created_at),
		updatedAt: new Date(updated_at),
	}
}

export const ProductionSocketStagePayload = (
	stage: IProductionSocketStageModel,
): IProductionSocketStagesCreatePayload => ({
	id: stage.id,
	positions: stage.positions
		? stage.positions.map(position => {
				let machineId: number | null = null
				if (position.machineID) {
					machineId = position.machineID
				} else if (position.machine?.id) {
					machineId = position.machine.id
				}
				return {
					id: position.id ?? undefined,
					machine_id: machineId,
					is_active: position.isActive,
				}
			})
		: [],
})

export const ProductionSocketToUpdatePayload = (
	stages: IProductionSocketStageModel[],
): IProductionSocketUpdatePayload => ({
	stages: stages ? stages.filter(s => s.isAdded).map(stage => ProductionSocketStagePayload(stage)) : [],
})

export const ProductionSocketToCreatePayload = (
	stages: IProductionSocketStageModel[],
): IProductionSocketCreatePayload => ({
	stages: stages ? stages.filter(s => s.isAdded).map(stage => ProductionSocketStagePayload(stage)) : [],
})
